export const registerNodeTemplate = (diagram: go.Diagram, categoryName: string, nodeTemplate: go.Node) =>
  diagram.nodeTemplateMap.add(categoryName, nodeTemplate);

export const registerLinkTemplate = (diagram: go.Diagram, categoryName: string, linkTemplate: go.Link) =>
  diagram.linkTemplateMap.add(categoryName, linkTemplate);

export const registerGroupTemplate = (diagram: go.Diagram, categoryName: string, groupTemplate: go.Group) =>
  diagram.groupTemplateMap.add(categoryName, groupTemplate);
